import type { PerformanceDatapoint } from 'owa-analytics';
import { DatapointStatus } from 'owa-analytics';

// https://www.apollographql.com/docs/react/data/error-handling/#error-types
export const hasError = (response: any): any => {
    const { errors, error } = response;
    return errors?.length || error?.networkError;
};

export const logAPIError = (response: any, perfDatapoint: PerformanceDatapoint): void => {
    const { errors, error } = response;
    if (error?.networkError) {
        //Handle Network Error
        perfDatapoint.addCustomData({
            entryPoint: 'booking',
            exceptionName: 'Network Error',
            responseDetails: JSON.stringify(error),
        });
    } else {
        //Handle GraphQL Error
        perfDatapoint.addCustomData({
            entryPoint: 'booking',
            exceptionName: 'GraphQL Error',
            responseDetails: JSON.stringify(errors?.[0]),
        });
    }
    perfDatapoint.endWithError(DatapointStatus.ServerError);
};
